import React from "react";
import ApiService from "../../Services/ApiService";
import AlertService from "../../Services/AlertService";
import queryString from "query-string";
import "../../style/styles.css"
import PrivateRoute from "../../_helpers/privateRoute";
import ClientGeneral from "./clientGeneral"
import ClientAudienceList from "./listClientAudiences"


class AddClientForm extends React.Component {

    // default state
    state = {
        data: {
            client_name: "",
            linkedin_account_id: "",
            linkedin_organization_id: "",
            account_currency: "USD",
            monthly_accounts: "",
            start_day: ""
        },
        is_loading: true,
        is_new: true,
        header: "",
        active: 'general'
    };

    componentDidMount() {
        let params = queryString.parse(this.props.location.search);

        if (params) {
            let clientId = params.client_id;
            if (clientId) {
                const url = "/api/clients/fetch?client_id=" + clientId;
                ApiService.get(url)
                    .then(response => {
                        if (response.data.Success) {
                            let client = response.data.Client;
                            if (client) {
                                this.setState({
                                    data: client,
                                    is_loading: false,
                                    is_new: false,
                                    header: "Edit Client",
                                    active: this.getActiveTab()
                                })
                            }
                        } else {
                            this.props.history.push("/clients");
                        }
                       
                    })
                    .catch(error => {
                        AlertService.error('Error loading client information')
                    })
            } else {
                // new client
                this.setState({
                    data: { ...this.state.data },
                    is_loading: false,
                    is_new: true,
                    header: "New Client"
                })
            }
        }
    }

    getActiveTab = () => {
        let path = this.props.location.pathname;
        if (path === '/clients/audience') {
            return 'audience';
        } else {
            return 'general';
        }
    }

    onNavClick = (value) => {
        this.setState({ active: value });

        switch (value) {
            case "audience":
                this.props.history.push("/clients/audience?client_id=" + this.state.data.client_id);
                return;
            default: this.props.history.push("/clients/add?client_id=" + this.state.data.client_id);
        }
    }

    render = () => {
        let navTabs = null;

        if (!this.state.is_new) {
            navTabs = (
                            <div className="nav">
                                <ul className="nav-links">
                                    <li className={this.state.active === "general" ? "selected nav-item" : "nav-item"}
                                        onClick={() => this.onNavClick("general")}>
                                        General
                                    </li>
                                    <li className={this.state.active === "audience" ? "selected nav-item" : "nav-item"} onClick={() => this.onNavClick("audience")}>
                                        Audience
                                    </li>
                                </ul>
                            </div>
            )
        }

        if (!this.state.is_loading) {
            return (

                <div className="page-main">
                    <div className="page-content">
                        <div>
                            {navTabs}
                        </div>

                        <div className="main-component">
                            <PrivateRoute
                                path="/clients/add"
                                data={this.state}
                                component={ClientGeneral}
                            />
                            <PrivateRoute
                                path="/clients/audience"
                                data={this.state.data}
                                updateState={this.updateState}
                                component={ClientAudienceList}
                            />

                        </div>

                    </div>
                </div>
            )
        } else {
            return (
                //TODO: add error message loading the data or rendering the form
                <div></div>
            )
        }
    }
}

export default AddClientForm;
